import { Fragment, useState, useEffect } from "react";
import {EditStore, Header, UserAddEdit} from './';
import { api, constants, date_helpers, ui_helpers } from "../helpers";
import { default as useUserStore } from "../hooks/useUserStore";
import Alert from "react-s-alert-v3";
import _, { trim } from "lodash";
import { Loading } from "./";
import {
  Alert as RSAlert,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  TabContent,
  Table,
  TabPane,
  Collapse,
} from "reactstrap";
import CreditCard from "@repay/react-credit-card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import ToggleButton from "react-toggle-button";
import { useParams } from "react-router-dom";

const tabNames = {
  Details: "1",
  Companies: "2",
  Manufacturers: "3",
  Users: "4",
  Payments: "5",
  TransferMethods: "6",
};

const DataRow = (props) => {
  return (
    <Row className="rowSpacing">
      <Col xs="4">
        <strong>{props.header}</strong>
      </Col>
      <Col xs="8">{props.data}</Col>
    </Row>
  );
};

const EMPTY_CARD = {
  cardNo: "",
  cardMMYY: "",
  cardCVC: "",
  cardZip: "",
};

const EMPTY_ACH = {
  routingNo: "",
  accountNo: "",
  holderFullName: "",
  accountType: constants.BANKING_ACCOUNT_TYPES[0].value,
  bankName: "",
  entryClass: constants.BANKING_ACCOUNT_TYPES[0].entryClass,
  type: "ACHDebit",
}

export default function StoreAdmin(props) {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(tabNames.Details);
  const [routeStoreId, setRouteStoreId] = useState(id);
  const [store, setStore] = useState(constants.EMPTY_STORE);
  const [isEditingStore, setIsEditingStore] = useState(false);
  const [newUser, setNewUser] = useState(false);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [states, setStates] = useState([]);
  const [storeCompanies, setStoreCompanies] = useState([]);
  const [companyToSave, setCompanyToSave] = useState({});
  const [manufacturers, setManufacturers] = useState([]);
  const [storeManufacturers, setStoreManufacturers] = useState([]);
  const [manufacturerToSave, setManufacturerToSave] = useState({});
  const [unshapedProductList, setUnshapedProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isRTOAdmin, setIsRTOAdmin] = useState(false);
  const [isSysAdmin, setIsSysAdmin] = useState(false);
  const [isAnyCompanyAdmin, setIsAnyCompanyAdmin] = useState(false);
  const [isDealerAdmin, setIsDealerAdmin] = useState(false);
  const [activeStoreCompaniesOnly, setActiveStoreCompaniesOnly] = useState(true);
  const [loadingStoreCompanies, setLoadingStoreCompanies] = useState(false);
  const [editingStoreRegion, setEditingStoreRegion] = useState(null);
  const [companyDealerPriorities, setCompanyDealerPriorities] = useState([]);
  const [companyRegions, setCompanyRegions] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [isEditingPayment, setIsEditingPayment] = useState(false);
  const [isEditingCCPayment, setIsEditingCCPayment] = useState(false);
  const [dealerCard, setDealerCard] = useState({});
  const [achInfo, setAchInfo] = useState({});
  const [secureAchInfo, setSecureAchInfo] = useState({});
  const [secureCCInfo, setSecureCCInfo] = useState({});
  const [cardInfo, setCardInfo] = useState({});
  const [showAchInfo, setShowAchInfo] = useState(false);
  const [showCardInfo, setShowCardInfo] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [transferMethods, setTransferMethods] = useState([]);
  const [addTransferMethod, setAddTransferMethod] = useState(false);
  // const [addingCreditCard, setAddingCreditCard] = useState(false);
  const [addingACH, setAddingACH] = useState(true);
  const [acknowledge, setAcknowledge] = useState(false);
  // const [manualCard, setManualCard] = useState(null);
  // const [cardTransferInfo, setCardTransferInfo] = useState(EMPTY_CARD);
  const [achTransferInfo, setACHTransferInfo] = useState(EMPTY_ACH);

  const currentUser = useUserStore(x => x.currentUser);

  useEffect(() => {
    getStoreDetails();
    getCompaniesList();
    getRegions();
    getStoreCompanies();
    getManufacturers();
    getStoreUsers();
    getManufacturerDealerLots();
    getCompanyDealerRegionPriorities();
    getDealerPaymentInfo();
  }, []);

  useEffect(() => {
    if (!store) return;
    getPermissions();
  }, [store]);

  useEffect(() => {
    if (activeTab === tabNames.TransferMethods) {
      getTransferMethods();
    } else {
      setTransferMethods([]);
    }
  }, [activeTab])

  function toggle(tab) {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  const shapeCompanyRegions = (list) => {
    if (list && list.length && states && states.length) {
      let newCompanyRegions = [];
      const groupedByRegion = _.groupBy(list, (e) => e.regionId);
      for (const regionId in groupedByRegion) {
        const regionKey = parseInt(regionId, 10);
        const region = _.find(states, (s) => s.id === regionKey);
        newCompanyRegions.push({
          regionId: regionKey,
          regionName: region?.label,
          companyList: groupedByRegion[regionId],
        });
      }
      return {
        companyRegionList: _.sortBy(newCompanyRegions, (r) => r.regionName),
        selectedStateList: _.map(states, (s) => ({
          ...s,
          selected: _.some(newCompanyRegions, (cr) => cr.regionId === s.id),
        })),
      };
    } else {
      return [];
    }
  };

  const getCompanyRegions = (companyId) => {
    return api
      .fetch(`company/CompanyRegionsList/${companyId}`)
      .then((r) => {
        const { companyRegionList, selectedStateList } = shapeCompanyRegions(r.data.data);
        setCompanyRegions(companyRegionList);
        setSelectedStates(selectedStateList);
      })
      .catch((error) => Alert.error("There was an error loading the company state list"));
  };

  function getPermissions() {
    const rtoAdmin = ui_helpers.isAnyRTOCompanyAdmin(currentUser);
    setIsRTOAdmin(rtoAdmin);
    setIsSysAdmin(ui_helpers.isSystemAdministrator(currentUser));
    setIsDealerAdmin(ui_helpers.isDealerAdministrator(currentUser, routeStoreId));
    setIsAnyCompanyAdmin(rtoAdmin || ui_helpers.isAnyCompanyAdministrator(currentUser));
  }

  //Store Details Screen
  function getStoreDetails() {
    if (loading) return;
    setLoading(true);
    api
      .fetch(`store/GetStoreDetails/${routeStoreId}`)
      .then((response) => {
        setStore(
          ui_helpers.shapeStore(
            response.data.data, companies));
      })
      .catch((error) => Alert.error("There was an error loading the store details."))
      .finally(() => setLoading(false));
  }

  function toggleStoreEdit() {
    setIsEditingStore(true);
  }

  function saveStoreDetails(store, cashSaleHeaderImage) {
    let warnings = [];
    if (store.name === "") {
      warnings.push("Provide a name for this new store in order to save.");
    }
    if (store.abbr === "") {
      warnings.push("Provide an abbreviation for this new store in order to save.");
    }
    if (
      store.isOwner &&
      store.enableCashSales &&
      !store.company?.cashSaleHeaderImageExisted &&
      !cashSaleHeaderImage
    ) {
      warnings.push("Either provide a cash sale header image or choose to disable cash sales.");
    }
    if (
      !store.id &&
      store.isOwner &&
      (!store.company?.states || store.company?.states.length === 0)
    ) {
      warnings.push("Select at least 1 state in which this store does business.");
    }
    if (warnings.length) {
      Alert.warning(warnings.join(" "));
      return null;
    }
    if (warnings.length > 0) return;
    let vm = Object.assign({}, store);
    if (vm.isOwner) {
      vm.company = Object.assign({}, vm.company);
      vm = ui_helpers.prepareStoreCompanyPayload(vm);
    }
    api
      .post("store/SaveDealerDetails", vm)
      .then((response) => {
        if (response.data.success) {
          let newStore = ui_helpers.shapeStore(response.data.data, companies);
          if (vm.isOwner && cashSaleHeaderImage) {
            api
              .post_form_data(
                "Company/SaveHeader",
                ui_helpers.buildCaptiveHeaderPayload(newStore.companyId, cashSaleHeaderImage)
              )
              .then((r) => {
                if (!r.data.success) {
                  Alert.warning("There was an error saving the cash sale header image");
                }
                setStore(newStore);
                setIsEditingStore(false);
              })
              .catch((error) => console.error(error));
          }
          setStore(newStore);
          setIsEditingStore(false);
        } else {
          Alert.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        Alert.error("There was an error saving the store details.");
      });
  }

  //Store Companies Screen
  function getCompaniesList() {
    api
      .fetch("company/Companies")
      .then((response) => {
        setCompanies(ui_helpers.idNameToValueLabel(response.data.data));
      })
      .catch((error) => Alert.error("There was an error retrieving companies."));
  }

  function getStoreCompanies() {
    setLoadingStoreCompanies(true);
    api
      .fetch(`store/DealerCompanyList/${routeStoreId}`)
      .then((response) => {
        setStoreCompanies(response.data.data);
      })
      .catch((error) => Alert.error("There was an error retrieving the store companies."))
      .finally(() => setLoadingStoreCompanies(false));
  }

  const getRegions = () => {
    return api
      .fetch("reference/RegionList")
      .then((r) => {
        setStates(ui_helpers.idNameToValueLabel(r.data.data));
      })
      .catch((error) => Alert.error("There was an error loading the state list"));
  };

  function getSelectedCompany(company) {
    const selected_option = _.find(companies, (x) => x.label === company.label);
    if (selected_option) {
      return [selected_option];
    }
    return null;
  }

  function setSelectedCompany(option) {
    setCompanyToSave({
      value: option.value,
      label: option.label,
    });
  }

  function saveCompanyToStore() {
    const companyDealer = {
      CompanyId: companyToSave.value,
      DealerId: _.toInteger(routeStoreId),
    };
    api
      .post("company/AddCompanyDealer", companyDealer)
      .then((response) => {
        setStoreCompanies([...storeCompanies, response.data.data]);
        setCompanyToSave({});
      })
      .catch((error) => Alert.error("There was an error adding the company."));
  }

  function activateCompanyDealer(cd) {
    const companies = storeCompanies.slice();
    const foundCompany = _.find(companies, (x) => x.id === cd.companyId);
    const CompanyDealerDto = {
      Id: cd.id,
      CompanyId: cd.companyId,
      DealerId: cd.dealerId
    };
    api
      .post("company/ActivateCompanyDealer", CompanyDealerDto)
      .then((response) => {
        const activated = response.data.data;
        foundCompany.deactivatedAt = activated.deactivatedAt;
        foundCompany.deactivatedByUserId = activated.deactivatedByUserId;
        setStoreCompanies(companies);
      })
      .catch((error) => Alert.error("There was an error activating the company store"));
  }

  function deactivateCompanyDealer(cd) {
    const companies = storeCompanies.slice();
    const foundCompany = _.find(companies, (x) => x.id === cd.companyId);
    api
      .post("company/DeactivateCompanyDealer", {
        Id: cd.id,
        CompanyId: cd.companyId,
        DealerId: cd.dealerId
      })
      .then((response) => {
        const deactivated = response.data.data;
        foundCompany.deactivatedAt = deactivated.deactivatedAt;
        foundCompany.deactivatedByUserId = deactivated.deactivatedByUserId;
        setStoreCompanies(companies);
      })
      .catch((error) => Alert.error("There was an error deactivating the company store"));
  }

  //Manufacturer Products Screen
  function getManufacturers() {
    api
      .fetch("company/ManufacturerList")
      .then((response) => {
        setManufacturers(ui_helpers.idNameToValueLabel(response.data.data));
      })
      .catch((error) => Alert.error("There was an error retrieving manufacturers."));
  }

  function getManufacturerDealerLots() {
    api
      .fetch(`store/GetManufacturerDealerLots/${routeStoreId}`)
      .then((response) => {
        setUnshapedProductList(response.data.data);
        setStoreManufacturers(shapeManufactureProductsList(response.data.data));
      })
      .catch((error) =>
        Alert.error("There was an error retrieving the manufacturer products list.")
      );
  }

  function shapeManufactureProductsList(productsList) {
    const manufacturerNames = [];
    _.forEach(productsList, (product) => {
      manufacturerNames.push(product.manufacturerName);
    });
    const uniqueManufacturerNames = _.uniq(manufacturerNames);
    const manufacturerProductGroups = [];
    _.map(uniqueManufacturerNames, (name) => {
      const found = _.filter(productsList, (x) => x.manufacturerName === name);
      const products = shapeProductsRows(found);
      const deactivatedAtDate = findDeactivatedAtDate(name, found);
      const manufacturerId = findManufacturerId(name, found);
      const newGroup = {
        manufacturerName: name,
        manufacturerId: manufacturerId,
        manufacturerDealerDeactivatedAt: deactivatedAtDate,
        products: products,
      };
      manufacturerProductGroups.push(newGroup);
    });
    return _.orderBy(manufacturerProductGroups, "manufacturerName");
  }

  function shapeProductsRows(products) {
    const productRow = [];
    _.forEach(products, (product) => {
      if (product.associated) {
        productRow.push(product.productTypeName);
      }
    });
    return productRow;
  }

  function findDeactivatedAtDate(manufacturerName, products) {
    const deactivatedAt = _.find(products, (x) => x.manufacturerName === manufacturerName);
    return deactivatedAt.manufacturerDealerDeactivatedAt;
  }

  function findManufacturerId(manufacturerName, products) {
    const manufacturer = _.find(products, (x) => x.manufacturerName === manufacturerName);
    return manufacturer.manufacturerId;
  }

  function getSelectedManufacturer(manufacturer) {
    const selected_option = _.find(manufacturers, (x) => x.label === manufacturer.label);
    if (selected_option) {
      return [selected_option];
    }
    return null;
  }

  function setSelectedManufacturer(option) {
    setManufacturerToSave({
      value: option.value,
      label: option.label,
    });
  }

  function getProductTypeToggleValue(products, fieldName) {
    const item = _.find(products, (x) => x === fieldName);
    if (item) {
      return true;
    }
    return false;
  }

  function saveStoreManufacturer() {
    const manufacturer = {
      ManufacturerId: manufacturerToSave.value,
      DealerId: _.toInteger(routeStoreId),
    };
    api
      .post("manufacturer/SaveManufacturerDealer", manufacturer)
      .then((response) => {
        setManufacturerToSave({});
        getManufacturerDealerLots();
      })
      .catch((error) => Alert.error("There was an error adding the manufacturer."));
  }

  function activateStoreManufacturer(manDealer) {
    const manufacturerDealer = {
      Id: manDealer.Id,
      ManufacturerId: manDealer.manufacturerId,
      DealerId: _.toInteger(routeStoreId),
    };
    api
      .post(`manufacturer/ActivateManufacturerDealer`, manufacturerDealer)
      .then((response) => {
        getManufacturerDealerLots();
      })
      .catch((error) => Alert.error("There was an error activating the store."));
  }

  function deactivateStoreManufacturer(manDealer) {
    const manufacturerDealer = {
      Id: manDealer.Id,
      ManufacturerId: manDealer.manufacturerId,
      DealerId: _.toInteger(routeStoreId),
    };
    api
      .post(`manufacturer/DeactivateManufacturerDealer`, manufacturerDealer)
      .then((response) => {
        getManufacturerDealerLots();
      })
      .catch((error) => Alert.error("There was an error deactivating the store."));
  }

  function saveStoreManufacturerProducts(value, manufacturerProductGroup, productTypeName) {
    const editUnShapedProductList = unshapedProductList.slice();
    const product = _.find(editUnShapedProductList, (x) => x.productTypeName === productTypeName);
    const dealerProduct = {
      DealerId: _.toInteger(routeStoreId),
      ManufacturerId: manufacturerProductGroup.manufacturerId,
      ProductTypeId: product.productTypeId,
    };
    if (value === true) {
      api
        .post("store/DeactivateDealerProduct", dealerProduct)
        .then((response) => {
          getManufacturerDealerLots();
        })
        .catch((error) => Alert.error("There was an error activating the product."));
    } else {
      api
        .post("store/ActivateDealerProduct", dealerProduct)
        .then((response) => {
          getManufacturerDealerLots();
        })
        .catch((error) => Alert.error("There was an error activating the product."));
    }
  }

  //Store Users Screen
  function getStoreUsers() {
    api
      .fetch(`store/GetStoreUsers/${routeStoreId}`)
      .then((response) => {
        setUsers(response.data.data);
      })
      .catch((error) => Alert.error("There was an error retrieving the users."));
  }

  function handleRoleChange(value, userId, role) {
    let userRoleId = _.find(constants.roles, (x) => x.label === role).value;
    if (value) {
      //remove role
      const userRoles = _.find(users, (x) => x.id === userId).roles;
      const roleId = _.find(userRoles, (x) => x.typeOfUserRole === userRoleId).id;
      const data = {
        typeOfUserRole: userRoleId,
        userId: userId,
        dealerId: routeStoreId,
        id: roleId,
      };
      api.post("store/RemoveRole", data).then((r) => {
        if (r.data.success) {
          setUsers(r.data.data);
          Alert.success("Roles have been adjusted.");
        } else {
          Alert.warning("There was an error adjusting roles.");
        }
      });
    } else {
      const data = {
        typeOfUserRole: userRoleId,
        userId: userId,
        dealerId: routeStoreId,
      };
      //add role
      api.post("store/AddRole", data).then((r) => {
        if (r.data.success) {
          setUsers(r.data.data);
          Alert.success("The new role was saved.");
        } else {
          Alert.warning("There was an error saving the new role.");
        }
      });
    }
  }

  function loadCompanyDealerPriorities(companyId) {
    getCompanyRegions(companyId).then((x) => {
      api
        .post("company/GetCompanyDealerPriorities", {
          dealerId: routeStoreId,
          companyId: companyId,
        })
        .then((r) => {
          setCompanyDealerPriorities(r.data);
        });
    });
  }

  function onToggleCompanyDealerRegion(companyId, regionId) {
    api
      .post("company/ToggleCompanyDealerRegion", {
        dealerId: routeStoreId,
        companyId: companyId,
        regionId: regionId,
      })
      .then((r) => {
        setCompanyDealerPriorities(r.data);
      });
  }

  function onToggleDealerRTO(company) {
    const newValue = !company.isRTO;
    api
      .post("company/ToggleDealerRTO", { ...company, isRTO: newValue })
      .then((response) => {
        let list = storeCompanies.slice();
        const idx = _.findIndex(list, (x) => x.companyId === company.companyId);
        list[idx].isRTO = !list[idx].isRTO;
        setStoreCompanies(list);
        getCompanyDealerRegionPriorities();
      })
      .catch((error) => Alert.error("There was an error toggling company RTO sales."));
  }

  function onToggleDealerCashSales(company) {
    api
      .post("company/ToggleDealerCashSales", { ...company, isCashSales: !company.isCashSales })
      .then((response) => {
        let list = storeCompanies.slice();
        const idx = _.findIndex(list, (x) => x.companyId === company.companyId);
        list[idx].isCashSales = !list[idx].isCashSales;
        setStoreCompanies(list);
      })
      .catch((error) => Alert.error("There was an error toggling store cash sales."));
  }

  function getCompanyDealerRegionPriorities() {
    api.post("company/GetDealerRTOCompanyRegions", { Id: routeStoreId }).then((r) => {
      setPriorities(r.data.message);
    });
  }

  function getConflictRegions() {
    if (!states || !priorities) return [];
    let results = [];
    const groupedByRegion = _.groupBy(priorities, (e) => e.regionId);
    for (const regionId in groupedByRegion) {
      const regionIdInt = parseInt(regionId, 10);
      const region = _.find(states, (s) => s.id === regionIdInt);
      if (groupedByRegion[regionId].length > 1) {
        results.push({
          regionId: regionId,
          regionName: region?.label,
          companies: _.map(groupedByRegion[regionId], (p) => ({
            id: p.companyId,
            name: p.companyName,
            isPrimary: p.priority === 1,
          })),
        });
      }
    }
    return results;
  }

  function onSetCompanyDealerRegionPrimary(regionId, companyId) {
    api
      .post("company/SetCompanyDealerRegionPrimary", {
        dealerId: routeStoreId,
        companyId: companyId,
        regionId: regionId,
        prioritySeq: 1,
      })
      .then((r) => {
        getCompanyDealerRegionPriorities();
      })
      .catch((error) => {
        console.error(error);
        Alert.error("There was an error setting RTO company priority.");
      });
  }

  const regionsInConflict = priorities.length ? getConflictRegions() : [];

  // Payments Screen

  function toggleEditPayment() {
    setIsEditingPayment(!isEditingPayment);
  }

  function updateACHInfo(fieldName, value) {
    setAchInfo({
      ...achInfo,
      [fieldName]: value,
    });
  }

  function updateCardInfo(fieldName, value) {
    setCardInfo({
      ...cardInfo,
      [fieldName]: value,
    });
  }

  const validSelectStyle = {
    control: (base) => ({
      ...base,
      borderColor: "#5cb85c",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  const inValidSelectStyle = {
    control: (base) => ({
      ...base,
      borderColor: "#d9534f",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  function getAchAccountSelectColor() {
    if (showAchValidation) {
      return achValidation.accountType ? inValidSelectStyle : validSelectStyle;
    } else {
      return achPayment.accountType ? validSelectStyle : {};
    }
  }

  function validAchInfo() {
    const _warnings = [];
    if (trim(achInfo?.name).length < 4) {
      _warnings.push({
        field: "name",
        text: "Please enter a valid account holder name.",
      });
    }
    if (trim(achInfo?.routeNumber).length < 4) {
      _warnings.push({ field: "routeNumber", text: "Please enter a valid routing number." });
    }
    if (trim(achInfo?.accountNumber).length < 4) {
      _warnings.push({ field: "accountNumber", text: "Please enter a valid account number." });
    }
    if (trim(achInfo?.bankName).length < 4) {
      _warnings.push({ field: "bankName", text: "Please enter a valid bank name." });
    }
    if (!achInfo?.accountType) {
      _warnings.push({ field: "accountType", text: "Please select an account type." });
    }
    if (_warnings.length > 0) {
      setWarnings(_warnings);
      return;
    }
    return true;
  }

  function saveACHDetails() {
    if (!validAchInfo()) return;
    const achPayment = {
      name: achInfo?.name,
      routeNumber: achInfo?.routeNumber,
      accountNumber: achInfo?.accountNumber,
      accountType: achInfo?.accountType.label,
      dealerId: routeStoreId,
      bankName: achInfo?.bankName,
    };
    api
      .post(`store/SaveDealerACHDetails/${routeStoreId}`, achPayment)
      .then((response) => {
        if (response.data.success) {
          Alert.success("ACH details saved successfully");
          toggleEditPayment();
        } else {
          Alert.error(response.data.message);
        }
      })
      .catch((error) => Alert.error("There was an error saving the ACH details."));
  }

  function saveManualDealerCard(data) {
    if (!data) return;
    const card = Object.assign({}, dealerCard);
    card.dealerId = routeStoreId;
    card.expiryMonth = dealerCard.ccExpiryMonth;
    card.expiryYear = dealerCard.ccExpiryYear;
    setDealerCard(card);
    api
      .post("store/DealerCC", dealerCard)
      .then((r) => {
        if (r.data.success) {
          Alert.success("Card saved successfully.");
        } else {
          Alert.error(r.data.message);
        }
      })
      .catch((e) => console.error(e));
  }

  function getDealerPaymentInfo() {
    if (!routeStoreId) return;
    api
      .fetch(`store/GetDealerPaymentInformation/${routeStoreId}`)
      .then((response) => {
        if (response.data.success) {
          setSecureAchInfo(response.data.message.item2);
          setSecureCCInfo(response.data.data);
        }
      })
      .catch((error) => {
        Alert.error("There was an error retrieving the dealer payment info.");
      });
  }

  function fetchACHDetails() {
    api
      .fetch(`store/GetACHInformation/${routeStoreId}`)
      .then((response) => {
        if (response.data.success) {
          setAchInfo({
            ...achInfo,
            ...response.data.message,
            accountType: _.find(constants.BANKING_ACCOUNT_TYPES, (a) => a.label === response.data.message.accountType).value
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching ACH details", error);
        Alert.error("There was an error retrieving the ACH details.");
      });
  }

  function fetchCCDetails() {
    api
      .fetch(`store/GetCCInformation/${routeStoreId}`)
      .then((response) => {
        if (response.data.success) {
          setCardInfo({
            ...cardInfo,
            ...response.data.message,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching credit card details", error);
        Alert.error("There was an error retrieving the credit card details.");
      });
  }

  // Transfer Methods Screen
  function getTransferMethods() {
    api.fetch(`store/GetAllTransferMethods/${routeStoreId}`)
    .then((response) => {
      if (response) {
        var ach = _.map(response.data.data.item1, (m) => ({ ...m, type: "ACH" }));
        var cards = _.map(response.data.data.item2, (m) => ({ ...m, type: "Card" }));
        setTransferMethods([...ach, ...cards]);
      }
    })
    .catch((error) => {
      Alert.error("There was an error retrieving the transfer methods.");
    })
  };

  function deactivateTransferMethod(method) {
    api.post(`store/DeleteTransferPaymentMethod/${method.id}`)
    .then((response) => {
      if (response.data.success) {
        getTransferMethods();
        Alert.success("Transfer method has been removed.");
      }
    })
    .catch((error) => {
      Alert.error("There was an error deactivating the transfer method.");
    })
  }

  function isValidTransferMethod() {
    // if (addingCreditCard) {
    //   if (!manualCard || manualCard.ErrorMessage) {
    //     Alert.warning("Please verify and provide valid card information.");
    //     return false;
    //   }
    // }
    if (addingACH) {
      if (_.trim(achTransferInfo.routingNo).length < 4) {
        Alert.warning("Enter a valid routing number.");
        return false;
      }
      if (_.trim(achTransferInfo.accountNo).length < 4) {
        Alert.warning("Enter a valid account number.");
        return false;
      }
      if (_.trim(achTransferInfo.holderFullName).length < 4) {
        Alert.warning("Enter a valid account holder name.");
        return false;
      }
      if (_.trim(achTransferInfo.bankName).length < 4) {
        Alert.warning("Enter a valid bank name.");
        return false;
      }
    }
    return true;
  }

  // const onChangeCard = (field, value) => {
  //   setCardTransferInfo((prevCard) => ({
  //     ...prevCard,
  //     [field]: value,
  //   }));
  // }

  const onChangeACH = (field, value) => {
    setACHTransferInfo((prevACH) => ({
      ...prevACH,
      [field]: value,
    }));
    if (field === "accountType") {
      const selected = _.find(constants.BANKING_ACCOUNT_TYPES, (a) => a.value === value);
      if (selected) {
        setACHTransferInfo((prevACH) => ({
          ...prevACH,
          entryClass: selected.entryClass,
        }));
      }
    }
  }

  // function onVerifyCard() {
  //   const parsed = ui_helpers.parseManualCardInformation(
  //     cardTransferInfo.cardZip, cardTransferInfo.cardNo, cardTransferInfo.cardMMYY, cardTransferInfo.cardCVC);
  //   if (!parsed.ErrorMessage) {
  //     setManualCard(parsed);
  //   }
  // }

  function onSaveTransferMethod() {
    if (!isValidTransferMethod()) return;
    saveACHTransferMethod();
    // if (addingCreditCard) {
    //   saveCardTransferMethod();
    // }
    // if (addingACH) {
      // saveACHTransferMethod();
    // }
  }

  // function saveCardTransferMethod() {
  //   if (!manualCard) return;
  //   let payload = {
  //     ...manualCard,
  //     dealerId: routeStoreId,
  //   };
  //   api.post("store/DealerCC", payload)
  //     .then((r) => {
  //       if (r.data.success) {
  //         Alert.success("Card transfer method saved successfully.");
  //         setCardTransferInfo(EMPTY_CARD);
  //         setAddTransferMethod(false);
  //         setManualCard(null);
  //         getTransferMethods();
  //       } else {
  //         Alert.error(r.data.message);
  //       }
  //     })
  //     .catch((e) => {
  //       Alert.error("There was an error saving the card transfer method.");
  //       console.error("Error saving card transfer method", e);
  //     });
  // }

  function saveACHTransferMethod() {
    let payload = {
      ...achTransferInfo,
      name: achTransferInfo.holderFullName,
      routeNumber: achTransferInfo.routingNo,
      accountNumber: achTransferInfo.accountNo,
      dealerId: routeStoreId,
    };
    api.post(`store/SaveDealerACHDetails/${routeStoreId}`, payload)
      .then((response) => {
        if (response.data.success) {
          Alert.success("ACH details saved successfully");
          setACHTransferInfo(EMPTY_ACH);
          setAddTransferMethod(false);
          getTransferMethods();
        } else {
          Alert.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error saving ACH transfer method", error);
        Alert.error("There was an error saving the ACH details.")
      });
  }

  return (
    <>
      <Header toolbar admin storeAdmin storeName={store.name} loading={loading}>
        <div className="d-flex justify-content-center">
          <Button onClick={() => toggle(tabNames.Details)} active={activeTab === tabNames.Details}>
            Details
          </Button>
          {isSysAdmin || isRTOAdmin ? (
            <Fragment>
              <Button
                onClick={() => toggle(tabNames.Companies)}
                active={activeTab === tabNames.Companies}
              >
                Companies
              </Button>
              <Button
                onClick={() => toggle(tabNames.Manufacturers)}
                active={activeTab === tabNames.Manufacturers}
              >
                Manufacturers
              </Button>
            </Fragment>
          ) : null}
          {isSysAdmin || isAnyCompanyAdmin ? (
            <>
              <Button onClick={() => toggle(tabNames.Users)} active={activeTab === tabNames.Users}>
                Users
              </Button>
              {/* <SubNavigationDropdown buttonText="Payments">
                <DropdownItem onClick={() => toggle(tabNames.Payments)}>
                  Default Methods
                </DropdownItem>
                <DropdownItem onClick={() => toggle(tabNames.TransferMethods)}>
                  Saved Transfer Methods
                </DropdownItem>
              </SubNavigationDropdown> */}
              <Button
                onClick={() => toggle(tabNames.Payments)}
                active={activeTab === tabNames.Payments}
              >
                Payments
              </Button>
              <Button
                onClick={() => toggle(tabNames.TransferMethods)}
                active={activeTab === tabNames.TransferMethods}
              >
                Transfer Methods
              </Button>
            </>
          ) : null}
        </div>
      </Header>
      <Container fluid>
        <Card style={{ borderColor: "transparent" }}>
          <Row>
            <Col>
              <TabContent activeTab={activeTab} className="mt-2">
                <TabPane tabId={tabNames.Details}>
                  <Row className="mb-0">
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col>
                              <h2 className="page-title">{store ? store.name : ""} Details</h2>
                            </Col>
                            <Col>
                              {isEditingStore ? null : (
                                <Button
                                  size="sm"
                                  className="float-end btn-dark"
                                  onClick={toggleStoreEdit}
                                >
                                  <FontAwesomeIcon icon="edit" />
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          {isEditingStore ? (
                            <EditStore
                              store={store}
                              states={states}
                              isSysAdmin={isSysAdmin}
                              isRTOAdmin={isSysAdmin || isRTOAdmin}
                              companies={companies}
                              onSave={(s, cashSaleHeaderImage) =>
                                saveStoreDetails(s, cashSaleHeaderImage)
                              }
                              onCancel={() => setIsEditingStore(false)}
                            />
                          ) : (
                            <Row>
                              <Col>
                                <DataRow header="Store Name" data={store.name} />
                                <DataRow header="Abbreviation" data={store.abbr} />
                                {isSysAdmin || isRTOAdmin ? (
                                  <Fragment>
                                    <DataRow
                                      header="90 Days Same As Cash"
                                      data={store.sac ? ui_helpers.greenCheck() : ""}
                                    />
                                    <DataRow
                                      header="Can Set Retained Transfer"
                                      data={
                                        store.canSetRetainedStatus ? ui_helpers.greenCheck() : ""
                                      }
                                    />
                                  </Fragment>
                                ) : null}
                                <DataRow
                                  header="Can Own"
                                  data={store.companyId ? ui_helpers.greenCheck() : ""}
                                />
                                <DataRow
                                  header="Use Tablet Signature Capture"
                                  data={
                                    store.isTabletSignatureCapture ? ui_helpers.greenCheck() : ""
                                  }
                                />
                                <DataRow
                                  header="API Key"
                                  data={store.apiKey ? ui_helpers.greenCheck() : ui_helpers.redX()}
                                />
                                <DataRow
                                  header="Website API Key"
                                  data={
                                    store.wcApiKey ? ui_helpers.greenCheck() : ui_helpers.redX()
                                  }
                                />
                                <DataRow
                                  header="Website API Secret"
                                  data={
                                    store.wcApiSecret ? ui_helpers.greenCheck() : ui_helpers.redX()
                                  }
                                />
                                <DataRow
                                  header="Website URL"
                                  data={store.wcUrl ? ui_helpers.greenCheck() : ui_helpers.redX()}
                                />
                                <DataRow
                                  header="Carefree Api Key"
                                  data={
                                    store.carefreeApiKey
                                      ? ui_helpers.greenCheck()
                                      : ui_helpers.redX()
                                  }
                                />
                                <DataRow
                                  header="Building Tag Text"
                                  data={
                                    store.buildingTagText
                                      ? ui_helpers.greenCheck()
                                      : ui_helpers.redX()
                                  }
                                />
                                <DataRow
                                  header="Created At"
                                  data={`${date_helpers.formatDateToShortDate(
                                    store.createdAt
                                  )} By ${store.createdBy ? store.createdBy.name : ""}`}
                                />
                                <DataRow
                                  header="Last Updated At"
                                  data={`${date_helpers.formatDateToShortDate(
                                    store.lastUpdatedAt
                                  )} By ${store.lastUpdatedBy ? store.lastUpdatedBy.name : ""}`}
                                />
                                <DataRow
                                  header="Deactivated At"
                                  data={
                                    store.deactivatedAt
                                      ? `${date_helpers.formatDateToShortDate(
                                          store.deactivatedAt
                                        )} by ${
                                          store.deactivatedBy ? store.deactivatedBy.name : ""
                                        }`
                                      : "Still Active"
                                  }
                                />
                                <DataRow
                                  header="Notify Creator Upon Contract Approval"
                                  data={
                                    store.notifyUponContractApproval ? ui_helpers.greenCheck() : ""
                                  }
                                />
                                <DataRow
                                  header="Track Commissions"
                                  data={store.isTrackingCommission ? ui_helpers.greenCheck() : ""}
                                />
                                <DataRow
                                  header="RTO Pro Details"
                                  data={
                                    store.rtoProDealerId
                                      ? ui_helpers.greenCheck()
                                      : "No"
                                  }
                                />
                              </Col>
                            </Row>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId={tabNames.Companies}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <h2 className="page-title">{store ? store.name : ""} Companies</h2>
                        </CardHeader>
                        <CardBody>
                          {isSysAdmin || isDealerAdmin ? (
                            <Row>
                              <Col xs="3">
                                <Label>Company</Label>
                                <Select
                                  options={_.reject(companies, (cpy) =>
                                    _.some(storeCompanies, (cs) => cs.companyId === cpy.id)
                                  )}
                                  value={getSelectedCompany(companyToSave)}
                                  onChange={(option) => setSelectedCompany(option)}
                                />
                              </Col>
                              <Col xs="1" className="pt-4">
                                <Button
                                  size="sm"
                                  className="float-right btn-success mt-1 text-light"
                                  onClick={saveCompanyToStore}
                                >
                                  <FontAwesomeIcon icon="plus" />
                                </Button>
                              </Col>
                              <Col xs="4" className="pt-1">
                                <div className="mt-4">
                                  <input
                                    type="checkbox"
                                    style={{ transform: "scale(1.4)" }}
                                    checked={activeStoreCompaniesOnly}
                                    onClick={() =>
                                      setActiveStoreCompaniesOnly(!activeStoreCompaniesOnly)
                                    }
                                    className="m-2"
                                  />
                                  Active Only
                                </div>
                              </Col>
                            </Row>
                          ) : null}
                          {loadingStoreCompanies ? (
                            <Loading />
                          ) : (
                            <Row className="mt-3">
                              <Col xs="8">
                                <Table size="sm">
                                  <thead>
                                    <tr>
                                      <th>Company Name</th>
                                      <th>Cash Sales</th>
                                      <th>RTO</th>
                                      <th>RTO Regions</th>
                                      <th />
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {_.map(
                                      _.filter(storeCompanies, (cs) => !activeStoreCompaniesOnly || cs.deactivatedAt === null),
                                      (c) => (
                                        <tr
                                          key={c.id}
                                          className={
                                            editingStoreRegion && editingStoreRegion.id === c.id
                                              ? "bg-warning"
                                              : null
                                          }
                                        >
                                          <td>{c.companyName}</td>
                                          <td>
                                            {c.deactivatedAt === null ? (
                                              <ToggleButton
                                                value={c.isCashSales}
                                                activeLabel={"Yes"}
                                                inactiveLabel={"No"}
                                                onToggle={() => onToggleDealerCashSales(c)}
                                              />
                                            ) : null}
                                          </td>
                                          <td>
                                            {c.deactivatedAt === null ? (
                                              <ToggleButton
                                                value={c.isRTO}
                                                activeLabel={"Yes"}
                                                inactiveLabel={"No"}
                                                onToggle={() => onToggleDealerRTO(c)}
                                              />
                                            ) : null}
                                          </td>
                                          <td>
                                            {c.isRTO ? (
                                              <span>
                                                {c.regionCSV}
                                                <Button
                                                  title="Change region associations"
                                                  color="dark"
                                                  className="float-end text-light xs"
                                                  onClick={() => {
                                                    setEditingStoreRegion(c);
                                                    loadCompanyDealerPriorities(c.companyId);
                                                  }}
                                                >
                                                  <FontAwesomeIcon icon="edit" />
                                                </Button>
                                              </span>
                                            ) : null}
                                          </td>
                                          <td>
                                            {c.deactivatedAt === null ? (
                                              <Button
                                                size="sm"
                                                className="float-end btn-danger cf-danger text-light"
                                                onClick={() => deactivateCompanyDealer(c)}
                                              >
                                                <FontAwesomeIcon icon="trash-alt" />
                                              </Button>
                                            ) : (
                                              <Button
                                                size="sm"
                                                className="float-end btn-success cf-success text-light"
                                                onClick={() => activateCompanyDealer(c)}
                                              >
                                                Revive
                                              </Button>
                                            )}
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                              {editingStoreRegion && companyRegions && companyRegions?.length > 0 ? (
                                <Col>
                                  <Button
                                    size="sm"
                                    color="secondary"
                                    className="float-end"
                                    onClick={() => {
                                      setEditingStoreRegion(null);
                                      getStoreCompanies();
                                      getCompanyDealerRegionPriorities();
                                    }}
                                  >
                                    <FontAwesomeIcon icon="times-circle" />
                                  </Button>
                                  <h4 className="pt-2" style={{ textDecoration: "underline" }}>
                                    {editingStoreRegion.companyName} Regions
                                  </h4>
                                  {_.map(companyRegions, (r) => (
                                    <Row className="mb-2" key={`rgRTO-${r.regionName}`}>
                                      <Col xs={6}>{r.regionName}</Col>
                                      <Col xs={3}>
                                        <ToggleButton
                                          value={_.some(
                                            companyDealerPriorities,
                                            (p) =>
                                              p.dealerId === editingStoreRegion.dealerId &&
                                              p.regionId === r.regionId
                                          )}
                                          activeLabel="Yes"
                                          inactiveLabel="No"
                                          onToggle={() => onToggleCompanyDealerRegion(editingStoreRegion.companyId, r.regionId)}
                                        />
                                      </Col>
                                    </Row>
                                  ))}
                                </Col>
                              ) : null}
                            </Row>
                          )}
                          {(isSysAdmin || isDealerAdmin) && regionsInConflict?.length ? (
                            <Row>
                              <Col xs="12">
                                <h4 className="pt-2" style={{ textDecoration: "underline" }}>
                                  {store ? store.name : ""} Regions with more than a single RTO
                                  Company
                                </h4>
                                <Row>
                                  {_.map(regionsInConflict, (r) => (
                                    <Col className="region-panel" xs={3} key={`r-${r.regionName}`}>
                                      <div className="title">{r.regionName}</div>
                                      {_.map(r.companies, (cpy) => (
                                        <Row
                                          className="region-company"
                                          key={`rgRTO-${r.regionName}-${cpy.name}`}
                                        >
                                          <Col xs={6}>{cpy.name}</Col>
                                          <Col xs={6} className="pe-4">
                                            {cpy.isPrimary ? (
                                              <div className="float-end text-success fw-bold">
                                                <FontAwesomeIcon icon="check" /> Primary
                                              </div>
                                            ) : (
                                              <Button
                                                color="primary"
                                                className="float-end xs"
                                                style={{ fontSize: "0.8rem" }}
                                                title={`Switch ${cpy.name} to be the RTO company to receive all RTO sales process in ${r.regionName}`}
                                                onClick={() =>
                                                  onSetCompanyDealerRegionPrimary(
                                                    r.regionId,
                                                    cpy.id
                                                  )
                                                }
                                              >
                                                <FontAwesomeIcon icon="check" /> Set Primary
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                      ))}
                                    </Col>
                                  ))}
                                </Row>
                              </Col>
                            </Row>
                          ) : null}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId={tabNames.Manufacturers}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <h2 className="page-title">
                            {store ? store.name : ""} Manufacturer Products
                          </h2>
                        </CardHeader>
                        <CardBody>
                          <Row>
                            {isSysAdmin ? (
                              <Fragment>
                                <Col xs="3">
                                  <Label>Manufacturer</Label>
                                  <Select
                                    options={manufacturers}
                                    value={getSelectedManufacturer(manufacturerToSave)}
                                    onChange={(option) => setSelectedManufacturer(option)}
                                  />
                                </Col>
                                <Col xs="1">
                                  <br />
                                  <Button
                                    size="sm"
                                    className="float-end bg-success border-success cf-success"
                                    onClick={() => saveStoreManufacturer()}
                                  >
                                    <FontAwesomeIcon icon="plus" />
                                  </Button>
                                </Col>
                              </Fragment>
                            ) : null}
                            <Col xs="8">
                              <Table size="sm">
                                <thead>
                                  <tr>
                                    <th>Manufacturer</th>
                                    <th>Gazebo</th>
                                    <th>Carport</th>
                                    <th>Playhouse</th>
                                    <th>Container</th>
                                    <th>Storage Building</th>
                                    <th>Animal Shelter</th>
                                    <th />
                                  </tr>
                                </thead>
                                <tbody>
                                  {storeManufacturers.map((m) => (
                                    <tr key={m.manufacturerName}>
                                      <th>{m.manufacturerName}</th>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(m.products, "Gazebo")}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(value) =>
                                            saveStoreManufacturerProducts(value, m, "Gazebo")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(m.products, "Carport")}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(value) =>
                                            saveStoreManufacturerProducts(value, m, "Carport")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(m.products, "Playhouse")}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(value) =>
                                            saveStoreManufacturerProducts(value, m, "Playhouse")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(m.products, "Container")}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(value) =>
                                            saveStoreManufacturerProducts(value, m, "Container")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(
                                            m.products,
                                            "Storage Building"
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(value) =>
                                            saveStoreManufacturerProducts(
                                              value,
                                              m,
                                              "Storage Building"
                                            )
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={getProductTypeToggleValue(
                                            m.products,
                                            "Animal Shelter"
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(_value) => {
                                            const val = m.products.includes("Animal Shelter");
                                            saveStoreManufacturerProducts(val, m, "Animal Shelter");
                                          }}
                                        />
                                      </td>
                                      <td>
                                        {m.manufacturerDealerDeactivatedAt === null ? (
                                          <Button
                                            size="sm"
                                            className="float-end btn-delete cf-danger"
                                            onClick={() => deactivateStoreManufacturer(m)}
                                          >
                                            <FontAwesomeIcon icon="trash-alt" />
                                          </Button>
                                        ) : (
                                          <Button
                                            size="sm"
                                            className="float-end bg-success border-success cf-success"
                                            onClick={() => activateStoreManufacturer(m)}
                                          >
                                            Revive
                                          </Button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId={tabNames.Users}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col>
                              <h2 className="page-title">{store ? store.name : ""} Users</h2>
                            </Col>
                            <Col>
                              <Button
                                size="sm"
                                className="float-end bg-cf-success border-success"
                                onClick={() => setNewUser(!newUser)}
                              >
                                <FontAwesomeIcon icon={newUser ? "minus" : "plus"} /> User
                              </Button>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          {!newUser && (
                            <Table size="sm">
                              <thead>
                                <tr>
                                  <th>User Name</th>
                                  <th>Administrator</th>
                                  <th>Contract Creator</th>
                                  <th>Contract Viewer</th>
                                  <th>Driver</th>
                                  <th>Dispatcher</th>
                                  <th>Transport Viewer</th>
                                  <th>Inventory Viewer</th>
                                  <th>Report Viewer</th>
                                  <th />
                                </tr>
                              </thead>
                              <tbody>
                                {users?.length &&
                                  users.map((u) => (
                                    <tr key={u.id}>
                                      <th>
                                        {u.firstName} {u.lastName} ({u.name})
                                      </th>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole === constants.ROLE_IDS.Administrator
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Administrator")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole ===
                                              constants.ROLE_IDS.ContractCreator
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Contract Creator")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole ===
                                              constants.ROLE_IDS.ContractViewer
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Contract Viewer")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) => ur.typeOfUserRole === constants.ROLE_IDS.Driver
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) => handleRoleChange(v, u.id, "Driver")}
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole === constants.ROLE_IDS.Dispatcher
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) => handleRoleChange(v, u.id, "Dispatcher")}
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole ===
                                              constants.ROLE_IDS.TransportViewer
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Transport Viewer")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole ===
                                              constants.ROLE_IDS.InventoryViewer
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Inventory Viewer")
                                          }
                                        />
                                      </td>
                                      <td align="center">
                                        <ToggleButton
                                          value={_.some(
                                            u.roles,
                                            (ur) =>
                                              ur.typeOfUserRole === constants.ROLE_IDS.ReportViewer
                                          )}
                                          activeLabel={"Yes"}
                                          inactiveLabel={"No"}
                                          onToggle={(v) =>
                                            handleRoleChange(v, u.id, "Report Viewer")
                                          }
                                        />
                                      </td>
                                      <td>{/*buttons go here for editing*/}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </Table>
                          )}
                          {newUser && (
                            <UserAddEdit
                              currentUser={currentUser}
                              returnRoute=""
                              computedMatch={props.computedMatch}
                              manufacturer={false}
                              store={true}
                              cancel={() => setNewUser(false)}
                            />
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId={tabNames.Payments}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col>
                              <h2 className="page-title">ACH Information</h2>
                            </Col>
                            <Col className={"d-flex justify-content-end"}>
                              {isEditingPayment ? (
                                <ButtonGroup className={"float-end"}>
                                  <Button
                                    onClick={saveACHDetails}
                                    size={"sm"}
                                    className={"bg-success border-success"}
                                  >
                                    <FontAwesomeIcon icon={"save"} />
                                  </Button>
                                  <Button onClick={toggleEditPayment} size={"sm"}>
                                    <FontAwesomeIcon icon={"times-circle"} />
                                  </Button>
                                </ButtonGroup>
                              ) : (
                                <>
                                  {Object.keys(achInfo).length === 0 
                                    ? null 
                                    : (
                                    <Button
                                      onClick={() => {
                                        setShowAchInfo(!showAchInfo);
                                      }}
                                      size={"sm"}
                                      style={{ marginRight: "3px" }}
                                    >
                                      {showAchInfo ? "Hide" : "Show"} Info
                                    </Button>
                                  )}
                                  <Button
                                    onClick={() => {
                                      fetchACHDetails();
                                      toggleEditPayment();
                                    }}
                                    size={"sm"}
                                  >
                                    <FontAwesomeIcon icon={"edit"} />
                                  </Button>
                                </>
                              )}
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          {isEditingPayment ? (
                            <div>
                              <Row>
                                <Col>
                                  <Label>Account Holder Name</Label>
                                  <Input
                                    type="text"
                                    name="name"
                                    value={achInfo?.name}
                                    onChange={(event) => updateACHInfo(event.target.name, event.target.value)}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Label>Bank Name</Label>
                                  <Input
                                    type="text"
                                    name="bankName"
                                    value={achInfo?.bankName}
                                    onChange={(event) =>
                                      updateACHInfo(event.target.name, event.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Label>Account Number</Label>
                                  <Input
                                    type="text"
                                    name="accountNumber"
                                    value={achInfo?.accountNumber}
                                    onChange={(event) =>
                                      updateACHInfo(event.target.name, event.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className={"mt-2"}>
                                <Col>
                                  <Label>Routing Number</Label>
                                  <Input
                                    type="text"
                                    name="routeNumber"
                                    value={achInfo?.routeNumber}
                                    onChange={(e) => updateACHInfo(e.target.name, e.target.value)}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Label>Account Type</Label>
                                  <Select
                                    options={constants.BANKING_ACCOUNT_TYPES}
                                    onChange={(option) => updateACHInfo("accountType", option)}
                                    value={_.find(constants.BANKING_ACCOUNT_TYPES, (a) => {
                                      return a.value === achInfo?.accountType;
                                    })}
                                  />
                                </Col>
                              </Row>
                            </div>
                          ) : (
                            <Row>
                              <Col>
                                <DataRow
                                  header="Account Holder Name"
                                  data={
                                    achInfo && showAchInfo ? (
                                      <span>{achInfo.name}</span>
                                    ) : secureAchInfo || achInfo ? (
                                      "**********"
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                                <DataRow
                                  header="Bank Name"
                                  data={
                                    achInfo && showAchInfo ? (
                                      <span>{achInfo.bankName}</span>
                                    ) : secureAchInfo || achInfo ? (
                                      "**********"
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                                <DataRow
                                  header="Account Number"
                                  data={
                                    achInfo && showAchInfo ? (
                                      <span>{achInfo.accountNumber}</span>
                                    ) : secureAchInfo || achInfo ? (
                                      "**********"
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                                <DataRow
                                  header="Routing Number"
                                  data={
                                    achInfo && showAchInfo ? (
                                      <span>{achInfo.routeNumber}</span>
                                    ) : secureAchInfo || achInfo ? (
                                      "**********"
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                                <DataRow
                                  header="Account Type"
                                  data={
                                    achInfo && showAchInfo ? (
                                      <span>{achInfo.accountType}</span>
                                    ) : secureAchInfo || achInfo ? (
                                      "**********"
                                    ) : (
                                      ""
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  {/* <Row className={"mt-3"}>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col>
                              <h2 className="page-title">Credit Card Information</h2>
                            </Col>
                            <Col className={"d-flex justify-content-end"}>
                              {isEditingCCPayment ? (
                                <ButtonGroup className={"float-end"}>
                                  <Button
                                    onClick={saveManualDealerCard}
                                    size={"sm"}
                                    className={"bg-success border-success"}
                                  >
                                    <FontAwesomeIcon icon={"save"} />
                                  </Button>
                                  <Button
                                    onClick={() => setIsEditingCCPayment(!isEditingCCPayment)}
                                    size={"sm"}
                                  >
                                    <FontAwesomeIcon icon={"times-circle"} />
                                  </Button>
                                </ButtonGroup>
                              ) : (
                                <Button
                                  onClick={() => {
                                    fetchCCDetails();
                                    setIsEditingCCPayment(!isEditingCCPayment)
                                  }}
                                  size={"sm"}
                                >
                                  <FontAwesomeIcon icon={"edit"} />
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          {isEditingCCPayment ? (
                            <div>
                              <Row>
                                <Col>
                                  <Label>Card Holder Name</Label>
                                  <Input
                                    type="text"
                                    name="cardHolderName"
                                    value={cardInfo?.cardHolderName}
                                    onChange={(event) =>
                                      updateCardInfo(event.target.name, event.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Label>Card Number</Label>
                                  <Input
                                    type="text"
                                    name="cardNumber"
                                    value={cardInfo?.cardNumber}
                                    onChange={(event) =>
                                      updateCardInfo(event.target.name, event.target.value)
                                    }
                                  />
                                </Col>
                              </Row>
                              <Row className={"mt-2"}>
                                <Col>
                                  <Label>Expiration Date</Label>
                                  <Input
                                    type="text"
                                    name="expiryDate"
                                    value={cardInfo?.expiryDate}
                                    onChange={(e) => updateCardInfo(e.target.name, e.target.value)}
                                  />
                                </Col>
                              </Row>
                            </div>
                          ) : (
                            <Row>
                              <Col>
                                <DataRow header="Card Holder Name" data={
                                  cardInfo && showCardInfo ? (
                                    <span>{cardInfo.cardHolderName}</span>
                                  ) : secureCCInfo || cardInfo ? (
                                    "**********"
                                  ) : (
                                    ""
                                  )
                                } />
                                <DataRow header="Card Number" data={
                                  cardInfo && showCardInfo ? (
                                    <span>{cardInfo.cardNumber}</span>
                                  ) : secureCCInfo || cardInfo ? (
                                    "**********"
                                  ) : (
                                    ""
                                  )
                                } />
                                <DataRow header="Expiration Date" data={
                                  cardInfo && showCardInfo ? (
                                    <span>{cardInfo.expiryDate}</span>
                                  ) : secureCCInfo || cardInfo ? (
                                    "**********"
                                  ) : (
                                    ""
                                  )
                                } />
                              </Col>
                            </Row>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row> */}
                </TabPane>
                <TabPane tabId={tabNames.TransferMethods}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <CardHeader>
                          <Row>
                            <Col className="d-flex align-items-center">
                              <h2 className="page-title">Saved Transfer Payment Methods</h2>
                            </Col>
                            <Col className={"d-flex justify-content-end"}>
                              <Button
                                size="sm"
                                className="float-end bg-cf-success border-success"
                                onClick={() => setAddTransferMethod(!addTransferMethod)}
                              >
                                <FontAwesomeIcon icon={addTransferMethod ? "minus" : "plus"} /> Add Method
                              </Button>
                            </Col>
                          </Row>
                        </CardHeader>
                        <CardBody>
                          <Collapse isOpen={addTransferMethod}>
                            <div style={{ border: "2px solid #E5E5FF", borderRadius: "10px", padding: "15px" }}>
                              <Form id="payment-form" className="form-horizontal">
                                <div
                                  style={{
                                    backgroundColor: "#E5E5FF",
                                    borderRadius: "4px",
                                    padding: "4px",
                                    fontSize: "0.85rem",
                                    marginBottom: "10px",
                                    width: "fit-content",
                                  }}
                                >
                                  <div style={{ fontWeight: "bold", fontSize: "16px" }}>AUTHORIZATION</div>
                                  <div>I authorize the charge(s) to my account as outlined in this form.</div>
                                </div>
                                <Row className="mb-1">
                                  <Col sm="3">
                                    <div className="d-flex flex-row">
                                      {/* <label
                                        className="form-control"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "0.8rem",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="visibility-type"
                                          checked={addingCreditCard}
                                          value={addingCreditCard}
                                          onChange={() => {
                                            setAddingCreditCard(true)
                                            setAddingACH(false)
                                          }}
                                        />{" "}
                                        Credit Card
                                      </label> */}
                                      {/* <label
                                        className="form-control"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "0.8rem",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <input
                                          type="radio"
                                          name="visibility-type"
                                          checked={addingACH}
                                          value={addingACH}
                                          onChange={() => {
                                            setAddingACH(true)
                                            setAddingCreditCard(false)
                                          }}
                                        />{" "}
                                        ACH
                                      </label> */}
                                    </div>
                                  </Col>
                                </Row>
                                {/* {addingCreditCard ? (
                                  <>
                                    <CreditCard cvc={cardTransferInfo.cardCVC} number={cardTransferInfo.cardNo} expiration={cardTransferInfo.cardMMYY} focused={"name"} />
                                    <Row className="mt-3 mb-1">
                                      <Col xs="5">
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={cardTransferInfo.cardNo}
                                          maxLength="20"
                                          placeholder="Card number"
                                          onChange={(e) => onChangeCard("cardNo", e.target.value)}
                                        />
                                      </Col>
                                      <Col xs="3">
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={cardTransferInfo.cardZip}
                                          maxLength="12"
                                          placeholder="Zip Code"
                                          onChange={(e) => onChangeCard("cardZip", e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col xs="5">
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={cardTransferInfo.cardMMYY}
                                          maxLength="4"
                                          placeholder="MMYY"
                                          onChange={(e) => onChangeCard("cardMMYY", e.target.value)}
                                        />
                                      </Col>
                                      <Col xs="3">
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={cardTransferInfo.cardCVC}
                                          maxLength="5"
                                          placeholder="CVC"
                                          onChange={(e) => onChangeCard("cardCVC", e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                    {manualCard ? (
                                      <div className="mt-2">
                                        {manualCard.ErrorMessage ? (
                                          <RSAlert color="warning" className="mb-0">
                                            {manualCard.ErrorMessage}
                                          </RSAlert>
                                        ) : (
                                          <RSAlert color="success" className="mb-0">
                                            The provided card information is valid.
                                          </RSAlert>
                                        )}
                                      </div>
                                    ) : null}
                                    <Button color="warning" className="text-light mt-2" onClick={onVerifyCard}>
                                      Verify Card Information
                                    </Button>
                                  </>
                                ) : addingACH ? ( */}
                                {addingACH ? (
                                  <>
                                    <Row className="mb-1">
                                      <Col sm="9">
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={achTransferInfo.routingNo}
                                          maxLength="9"
                                          style={{ marginBottom: "2px", float: "left" }}
                                          placeholder="Routing Number"
                                          onChange={(e) => onChangeACH("routingNo", e.target.value)}
                                        />
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={achTransferInfo.accountNo}
                                          maxLength="17"
                                          style={{ marginBottom: "2px", float: "left" }}
                                          placeholder="Account Number"
                                          onChange={(e) => onChangeACH("accountNo", e.target.value)}
                                        />
                                        <Input
                                          type="text"
                                          bsSize="sm"
                                          value={achTransferInfo.holderFullName}
                                          maxLength="70"
                                          style={{ marginBottom: "2px", float: "left" }}
                                          placeholder="Account Holder Full Name"
                                          onChange={(e) => onChangeACH("holderFullName", e.target.value)}
                                        />
                                        <Select
                                          options={constants.BANKING_ACCOUNT_TYPES}
                                          onChange={(option) => onChangeACH("accountType", option.value)}
                                          value={_.find(constants.BANKING_ACCOUNT_TYPES, (a) => a.value === achTransferInfo.accountType)}
                                          styles={{
                                            container: (provided) => ({
                                              ...provided,
                                              float: "left",
                                              marginBottom: "2px",
                                              width: "100%",
                                            }),
                                          }}
                                        />
                                        <Input
                                          type="text"
                                          placeholder="Bank Name"
                                          bsSize="sm"
                                          value={achTransferInfo.bankName}
                                          maxLength="70"
                                          style={{ float: "left" }}
                                          onChange={(e) => onChangeACH("bankName", e.target.value)}
                                        />
                                      </Col>
                                    </Row>
                                  </>
                                ) : null}
                              </Form>
                              <div className="d-flex flex-column mt-3">
                                <div className="d-flex align-items-center">
                                  <Input
                                    type="checkbox"
                                    checked={acknowledge}
                                    onChange={(e) => setAcknowledge(e.target.checked)}
                                    style={{ minWidth: "1.2em" }}
                                    required
                                  />
                                  <p className="mb-0 ms-2" style={{
                                    fontSize: "0.95rem",
                                  }}>
                                  By checking this box, I acknowledge that this account belongs to {store.name}. I am authorized to initiate debits and it will be used for payment transfers to associated companies (RTO Provider or Manufacturer).
                                  </p>
                                </div>
                                <ButtonGroup className="mt-3" style={{ width: "fit-content" }}>
                                  <Button
                                    color="primary"
                                    className="float-end"
                                    onClick={onSaveTransferMethod}
                                    disabled={!acknowledge}
                                    // disabled={!acknowledge || (
                                    //   addingCreditCard ? (!manualCard || manualCard.ErrorMessage) : false
                                    // )}
                                  >
                                    Save
                                  </Button>
                                  <Button color="secondary"
                                    onClick={() => {
                                      setAddTransferMethod(false);
                                      // setManualCard(null);
                                      // setCardTransferInfo(EMPTY_CARD);
                                      setACHTransferInfo(EMPTY_ACH);
                                      setAcknowledge(false);
                                    }}
                                  >
                                    Cancel
                                  </Button>
                                </ButtonGroup>
                              </div>
                            </div>
                          </Collapse>
                          <Table size="sm">
                            <thead>
                              <tr>
                                {/* <th>Name</th> */}
                                <th>Type</th>
                                <th>Last 4 Digits</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {transferMethods?.length > 0 && _.map(transferMethods, (m) => (
                                <tr key={m.id}>
                                  {/* <td align="center">
                                    {m.name ? m.name : "N/A"}
                                  </td> */}
                                  <td align="left">
                                    {m.type}
                                  </td>
                                  <td align="left">
                                    {m.secureDisplay}
                                  </td>
                                  <td>
                                    <Button
                                      size="sm"
                                      className="float-end btn-danger cf-danger text-light"
                                      onClick={() => deactivateTransferMethod(m)}
                                    >
                                      <FontAwesomeIcon icon="trash-alt" />
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
}
